module.exports = __webpack_public_path__ + "static/media/floor_tom_4.20c93860.png";